import { useParams } from "react-router-dom";
import { DashboardLayout } from "./_common/DashboardLayout";
import { useEffect, useState } from "react";
import { userGetService, userUpdateService } from "../utils/api";
import { notifyError, notifySuccess } from "../utils/notify";
import { UserForm } from "./components/UserForm";

export function UserEdit() {

    const params = useParams();
    const { id } = params;

    // useState
    const [user, setUser] = useState(null);

    const getUser = () => {
        userGetService(id, (data) => {
            if (data.success) {
                setUser(data.user)
            } else {
                notifyError(data.message)
            }
        })
    }

    useEffect(() => {
        getUser();
    }, [id]);

    if (!user) {
        return <DashboardLayout route="/users/edit">
            <h1 className="text-4xl font-semibold">Edit User</h1>
            <div>Loading...</div>
        </DashboardLayout>
    }

    return (
        <DashboardLayout route="/users">
            <h1 className="text-4xl font-semibold">Edit User</h1>

            <div className="mt-6">
                <div className="grid grid-cols-3 gap-4">
                    <div className="col-span-1">
                        <UserForm 
                            initialData={user}
                            onSubmit={(data) => {
                                userUpdateService({...user, ...data}, (data) => {
                                    if (data.success) {
                                        notifySuccess(data.message)
                                        getUser();
                                    } else {
                                        notifyError(data.message)
                                    }
                                })
                            }} 
                        />
                    </div>
                </div>
            </div>
        </DashboardLayout>
    )
}